<div class="container">
  <div class="door-list mt-3 mb-3" *ngIf="relays.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th class="text-center">#</th>
        <th class="text-center">Name</th>
        <th class="text-center">Relay Board</th>
        <th class="text-center">Relay Id</th>
        <th class="text-center">Description</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let relay of relays">
        <th class="text-center">{{ relay.id }}</th>
        <td class="text-center">{{ relay.name }}</td>
        <td class="text-center">{{ getRelayBoard(relay.relayBoardId) }}</td>
        <td class="text-center">{{ relay.relayId }}</td>
        <td class="text-center">{{ relay.description }}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(relay)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td class="text-center">
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(relay)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
